import script from "./WordSearchEngine.vue?vue&type=script&setup=true&lang=js"
export * from "./WordSearchEngine.vue?vue&type=script&setup=true&lang=js"

import "./WordSearchEngine.vue?vue&type=style&index=0&id=0b145681&scoped=true&lang=css"

import exportComponent from "C:\\Cwiczenia Programowanie Wojtek\\Vue Shop-FCC\\lang-cross\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b145681"]])

export default __exports__